'use strict';

var style = require('./style');

module.exports = style({
  prop: 'borderColor',
  key: 'colors'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/border-color.js
// module id = 367
// module chunks = 168707334958949